import { render, staticRenderFns } from "./handicaps.vue?vue&type=template&id=6b22db3e"
import script from "./handicaps.vue?vue&type=script&lang=js"
export * from "./handicaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports